import RelacaoClientes from './RelacaoClientes'

export default function RelacaoVendedores() {
  return <RelacaoClientes tipo="vendedores" titulo="Relação de Vendedores" tituloRelatorio="RELAÇÃO DE VENDEDORES" />
}
